export default class FeaturedEvents {
    constructor() {
        this.container = document.querySelector('.featured-events');
        if (!this.container) return;

        this.eventCardsContainer = this.container.querySelector('.event-cards');
        this.events = this.eventCardsContainer.querySelectorAll('.event-card-wrapper');
        this.loadMoreButton = this.container.querySelector('.load-more-featured-events');
        this.filterLinks = this.container.querySelectorAll('.event-filter');
        this.isMobile = window.innerWidth < 1024;
        this.postsPerPage = this.isMobile ? 4 : 9;
        this.currentTypeFilter = 'all';
        this.currentVerticalFilter = 'all';
        this.filteredEvents = [...this.events];
        this.init();
    }

    init() {
        this.applyFilters();
        this.updateLoadMoreButtonVisibility();
        this.attachEventListeners();
    }

    attachEventListeners() {
        this.filterLinks.forEach(link => {
            link.addEventListener('click', (e) => this.handleFilterChange(e));
        });
        this.loadMoreButton.addEventListener('click', () => this.loadMoreEvents());

        window.addEventListener('resize', this.debounce(() => {
            const newIsMobile = window.innerWidth < 1024;
            if (newIsMobile !== this.isMobile) {
                this.isMobile = newIsMobile;
                this.postsPerPage = this.isMobile ? 4 : 9;
                this.applyFilters();
            }
        }, 250));
    }

    handleFilterChange(e) {
        e.preventDefault();
        const filterType = e.target.dataset.eventTypeId || 'all';
        const filterVertical = e.target.dataset.verticalId || 'all';

        if (e.target.classList.contains('event-type-filter')) {
            this.currentTypeFilter = filterType;
        } else if (e.target.classList.contains('focus-area-filter')) {
            this.currentVerticalFilter = filterVertical;
        }

        this.applyFilters();
    }

    applyFilters() {
        this.filteredEvents = [...this.events].filter(event => {
            const eventType = event.dataset.eventTypeId;
            const eventVertical = event.dataset.verticalId;
            return (this.currentTypeFilter === 'all' || this.currentTypeFilter === eventType) &&
                (this.currentVerticalFilter === 'all' || this.currentVerticalFilter === eventVertical);
        });

        this.events.forEach(event => event.classList.add('hidden'));
        this.filteredEvents.slice(0, this.postsPerPage).forEach(event => event.classList.remove('hidden'));
        this.updateLoadMoreButtonVisibility();
    }

    loadMoreEvents() {
        const visibleEventsCount = this.filteredEvents.filter(event => !event.classList.contains('hidden')).length;
        this.filteredEvents.slice(visibleEventsCount, visibleEventsCount + this.postsPerPage).forEach(event => event.classList.remove('hidden'));
        this.updateLoadMoreButtonVisibility();
    }

    updateLoadMoreButtonVisibility() {

        const visibleEventsCount = this.filteredEvents.filter(event => !event.classList.contains('hidden')).length;
        const isMoreEventsToLoad = visibleEventsCount < this.filteredEvents.length;
        console.log(this.filteredEvents.length, visibleEventsCount, isMoreEventsToLoad);
        if (isMoreEventsToLoad) {
            this.loadMoreButton.classList.remove('hidden');
        } else {
            this.loadMoreButton.classList.add('hidden');
        }
    }

    debounce(func, wait, immediate) {
        let timeout;
        return function() {
            const context = this, args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                timeout = null;
                if (!immediate) func.apply(context, args);
            }, wait);
            if (immediate && !timeout) func.apply(context, args);
        };
    }
}
